import { styled } from '@mui/system'
import { media } from '@core/hooks/useBreakpoints/useBreakpoints'

export const CardTitle = styled('div')`
    margin-bottom: 24px;
`

export const AccountDetailsGrid = styled('div')`
    display: grid;
    grid-template-columns: 2fr 1fr;
    column-gap: 32px;

    ${media.lg`
        grid-template-columns: 1fr;
        row-gap: 24px;
    `}
`

export const AccountFields = styled('div')`
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 32px;

    ${media.md`
        grid-template-columns: 1fr;
    `}

    .content-item {
        margin-bottom: 24px;
    }

    .account-name {
        word-break: break-all;
    }
`

export const DomainsColumn = styled('div')`
    .content-item {
        margin-bottom: 24px;
    }
`
